import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ifElse, isNil, complement, identity, pathOr } from 'ramda';
import componentBase from '../../../../../../../../src/lib/component-base';

let FlightMap = null;

@componentBase('FlightPositionalInformation')
export default class FlightPositionalInformation extends Component {
  static propTypes = {
    flight: PropTypes.object.isRequired,
    params: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      headerStyle: {
        margin: '15px 15px 15px 20px',
        fontWeight: 700,
      },
    };
  }

  componentDidMount() {
    const ifFlightMapIsNotNil = ifElse(
      flightMap => isNil(flightMap),
      () => FlightMap = require('./children/FlightMap/FlightMap').default,
      identity(),
    );

    ifFlightMapIsNotNil(FlightMap);
    this.forceUpdate();
  }

  render() {
    const {
      flight,
      params,
    } = this.props;

    const isNotNil = complement(isNil);

    const map = ifElse(
      flightMap => isNotNil(flightMap),
      () => (
        <FlightMap
          flight={flight}
          params={params}
        />
      ),
      () => (
        <div style={{ width: '100%', height: '100%' }} />
      ),
    );

    const ifFlightId = ifElse(
      flightId => isNotNil(flightId),
      () => map(FlightMap),
      () => <div />,
    );

    return ifFlightId(pathOr(undefined, ['flight', 'flightId']));
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightPositionalInformationSection/children/FlightPositionalInformation/FlightPositionalInformation.js